import React from 'react';
import RequestsTable from '../components/Dispute/RequestTable';

const DisputeRequestsPage = () => {
  return (
    <div className="flex flex-col gap-6">
      <RequestsTable />
    </div>
  );
};

export default DisputeRequestsPage;
